import { LoadingSpinner } from "@clipboard-health/ui-components";
import { Box } from "@mui/material";

export function PaymentsListLoader() {
  return (
    <Box
      sx={{
        display: "flex",
        height: "150px",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
      }}
      data-testid="payments-list-loader"
    >
      <LoadingSpinner size="large" />
    </Box>
  );
}
